module.exports = __webpack_public_path__ + "img/email.b6646c1f.png";